import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import SaIbAgreementPdf from "../assets/pdf/SA_IB_Agreement-int2.pdf";
import IbAgreementPdf from "../assets/pdf/IB_Agreement-int2.pdf";
import SalesAgreementPdf from "../assets/pdf/Sales_Agreement-int2.pdf";
import { useSelector } from "react-redux";
import getConfig from "config/config";

const SELLER_ROLE = "Seller";

const Footer = () => {
  const { t } = useTranslation();
  const config = getConfig();
  const { api, company, zendesk } = config;

  const { authData } = useSelector((state: any) => state.Dashboard);
  
  const isInvest = company.COMPANY_ID == 11;
  const countryOfResidenceId = authData.countryOfResidenceId;
  const userRole = authData?.userRoleType || "Partner";

  const pdfUrl =
    userRole === SELLER_ROLE
      ? SalesAgreementPdf
      : countryOfResidenceId == "192"
        ? SaIbAgreementPdf
        : IbAgreementPdf;

  const investLinks = [
    {
      url: "https://www.triveinvest.co.id/pdf/Privacy-Policy.pdf",
      label: t("privacypolicy"),
      external: true,
    },
    {
      url: "https://www.triveinvest.co.id/pdf/Terms_of_Business.pdf",
      label: t("termsofbusiness"),
      external: true,
    },
    {
      url: "https://www.triveinvest.co.id/tentang-kami/dokumen-legal",
      label: t("risknotification"),
      external: true,
    },
    {
      url: "https://www.triveinvest.co.id/tentang-kami/izin-kami",
      label: t("licenses"),
      external: true,
    },
  ];

  const generalLinks = [
    {
      url: "https://www.trive.com/int/about/legal-documents",
      label: t("termsandconditions"),
    },
    {
      url: pdfUrl,
      label:
        userRole === SELLER_ROLE ? t("serviceagreement") : t("ibagreement"),
      external: true,
    },
    { url: "/contact-us", label: t("support") },
  ];

  const links = isInvest ? investLinks : generalLinks;

  return (
    <React.Fragment>
      <footer className="footer px-4">
        <Container fluid>
          <Row>
            <Col
              sm={12}
              md={6}
              xl={isInvest ? 6 : 4}
              className="d-flex justify-content-between "
            >
              {isInvest ? (
                <span className="footer-company-text">
                  @ Trive Invest {new Date().getFullYear()}
                </span>
              ) : (
                <span className="footer-company-text">
                  Trive @ {new Date().getFullYear()}
                </span>
              )}
              {links.map(({ url, label, external }, index) => (
                <Link
                  key={`footer-${label}@${index}`}
                  to={url}
                  target={external ? "_blank" : "_self"}
                  rel={external ? "noopener noreferrer" : undefined}
                  className="footer-link-text"
                >
                  {label}
                </Link>
              ))}
            </Col>
          </Row>
          {isInvest ? (
            <Row>
              <Col sm={12} md={6} className="d-flex justify-content-between">
                <span className="footer-company-text">{t("support")} 5/24</span>
                <a href={`tel:150 898`} className="footer-company-text">
                  {t("call")}: 150 898
                </a>
                <a
                  href={`mailto:${zendesk.ZENDESK_SUPPORT_EMAIL}`}
                  className="footer-company-text"
                >
                  {t("email")}: {zendesk.ZENDESK_SUPPORT_EMAIL}
                </a>
              </Col>
            </Row>
          ) : null}
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
